// extracted by mini-css-extract-plugin
export default {"overlay":"PopupCard_overlay__AlDj8","card":"PopupCard_card__WHeR5","content":"PopupCard_content__ACUuP"};